import styles from "./AddNewDataAlert.module.scss";
import { NumberInput } from "src/components/inputs/NumberInput/NumberInput";
import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  minVolume: number | null;
  onMinVolumeChange: (value: number | null) => void;
  onValueModified: (modified: boolean) => void;
  initialMinVolume: number | null;
}

export const AddNewDataAlert: FC<Props> = ({
  minVolume,
  onMinVolumeChange,
  onValueModified,
  initialMinVolume,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    const isModified = minVolume !== null && minVolume !== initialMinVolume;
    onValueModified(isModified);
  }, [minVolume, initialMinVolume, onValueModified]);

  const handleMinVolumeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace(/\s+/g, "");

    if (!/^\d*$/.test(rawValue)) return;

    if (rawValue === "") {
      onMinVolumeChange(null);
    } else {
      const numValue = Number(rawValue);
      if (numValue >= 0) {
        onMinVolumeChange(numValue);
      }
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.alertType}>
        <span className={styles.label}>
          {t(
            "component.modal.trend_alerts.suggestions.alert_me_about",
            "Alert me about:",
          )}
        </span>
        <label className={styles.radioWrapper}>
          <input
            type="radio"
            name="suggestionsType"
            value="suggestions"
            checked={true}
            readOnly
            className={styles.radioInput}
          />
          <span className={styles.customRadio}></span>
          {t("component.modal.trend_alerts.suggestions.label", "Suggestions")}
        </label>
      </div>
      <div className={styles.inputs}>
        <div className={styles.inputGroup}>
          <label className={styles.inputLabel}>
            {t(
              "component.modal.trend_alerts.suggestions.min_volume",
              "Min Volume",
            )}
          </label>
          <NumberInput
            type="text"
            value={minVolume !== null ? minVolume.toString() : ""}
            placeholder="0"
            onChange={handleMinVolumeChange}
            width="200px"
            min={0}
            onKeyDown={(e) => {
              if (
                !/[0-9]/.test(e.key) &&
                e.key !== "Backspace" &&
                e.key !== "Delete" &&
                e.key !== "ArrowLeft" &&
                e.key !== "ArrowRight"
              ) {
                e.preventDefault();
              }
            }}
          />
        </div>
      </div>
      <div className={styles.confirm}>
        <span>
          {t("component.modal.trend_alerts.new_data_email_confirmation")}
        </span>
      </div>
    </div>
  );
};
